import FloatingCards from '../FloatingCards.js';
import GPUPhysicsSimulator from './GPUPhysicsSimulator.js';
import CardSystem from './CardSystem.js';

export default class World {
  constructor() {
    this.floatingCards = FloatingCards.getInstance();
    this.isSimulationStarted = false;

    this.setupWorld();
  }

  setupWorld() {
    this.floatingCards.appLoaded = true;
    this.physicsSimulator = new GPUPhysicsSimulator();
    this.cardSystem = new CardSystem(this.physicsSimulator);
  }

  startSimulation() {
    if (this.isSimulationStarted) return;
    this.isSimulationStarted = true;
  }

  update(delta) {
    this.cardSystem.update(delta);

    if (this.isSimulationStarted) {
      this.physicsSimulator.update(delta);
    }
  }
}
